import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Is this a physical book?',
    a: 'This is a digital toolkit including a PDF guide and editable templates (Canva/Google Sheets) for instant access.'
  }, {
    q: 'I have 20 half-finished planners. Why is this different?',
    a: "Those planners focused on the clock. This focuses on your chemistry. If you don't fix the dopamine deficit, no planner in the world will work."
  }, {
    q: 'Does this work for people without an official diagnosis?',
    a: 'Yes. If you struggle with focus, procrastination, and "starting friction," these tools will help regardless of a label.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-4 bg-[#0B1A2E]" data-id="element-34">
      <div className="max-w-3xl mx-auto animate-fade-in-up delay-100" data-id="element-35">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#F1F5F9] mb-12" data-id="element-36">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-37">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-[#2DD4BF] bg-[#112240]' : 'border-[#1A2F4A] bg-[#0B1A2E] hover:border-[#1A2F4A]/80'}`} data-id="element-38">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2DD4BF]" aria-expanded={isOpen} data-id="element-39">
                  <span className={`font-semibold pr-4 ${isOpen ? 'text-[#2DD4BF]' : 'text-[#F1F5F9]'}`} data-id="element-40">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#2DD4BF]' : 'text-[#94A3B8]'}`} data-id="element-41" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-42">
                  <p className="text-[#94A3B8] leading-relaxed" data-id="element-43">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}